export default "__VITE_ASSET__C6p6qcng__"